import { useQuery } from '@tanstack/react-query';
import { dashboardService, DashboardFilters } from '../services';

export const useDashboardStats = (filters?: DashboardFilters) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['dashboardStats', filters],
    queryFn: async () => {
      const response = await dashboardService.getStats(filters);
      return response.data;
    },
    refetchInterval: 60000, // Refetch every minute
  });

  return {
    stats: data,
    isLoading,
    error,
  };
};

export const useDashboardFilteredData = (filters?: DashboardFilters) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['dashboardFilteredData', filters],
    queryFn: async () => {
      const response = await dashboardService.getFilteredData(filters);
      return response.data;
    },
    enabled: !!filters, // Only fetch when filters are provided
  });

  return {
    data,
    isLoading,
    error,
  };
};
